<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 54V16.2534H38.691V54L25.0955 46.9409L11.5 54ZM13.533 50.4578L25.1206 44.5777L36.658 50.4578V18.3034H13.533V50.4578ZM46.467 44.531V8.05068H18.9813V6H48.5V44.531H46.467Z"
      fill="#383838"
    />
  </svg>
</template>
